<template>
  <generic-container
    :title="$t('quotation')"
    icon="file alternate"
    :header_buttons="header_buttons"
  >
    <div class="ui basic container segment">
      <div
        class="ui basic segment container form"
        style="padding: 0 0 15px 0"
        ref="form"
      >
        <h3 class="ui dividing header">{{ $t("quotation") }}</h3>
        <!-- <div class="ui form"> -->
        <div class="field">
          <label for>{{ $t("name") }}</label>
          <input type="text" name="name" v-model="quotation.name" />
        </div>
        <div class="ui error message"></div>
        <!-- </div> -->
      </div>

      <div class="ui grid container">
        <div class="four wide column" style="padding-left: 0; padding-top: 0;">
          <customer @select_customer="select_customer" />
        </div>
        <div
          class="twelve wide column"
          style="padding-right: 0; padding-top: 0;"
        >
          <cart ref="point_of_sale_cart" />
        </div>
      </div>
      <product @add_to_cart="add_to_cart" />
      <!-- <component
      :is="submodule.setup.plugin.component"
      :module="submodule"
      v-for="(submodule, index) in submodules"
      v-bind:key="index"
      @session_updated="session_updated"
      ref="submodule"
      ></component>-->
    </div>
  </generic-container>
</template>

<script>
import { local_api } from "@/utils";
import filters from "@/filters";
import Customer from "./Customer";
import Product from "@/modules/quotation/composer/product/Product";
import Cart from "@/modules/quotation/composer/cart/Cart";
import GenericContainer from "@/components/GenericContainer";
import { success_toast } from "../../../utils";

// @ is an alias to /src
export default {
  name: "QuotationComposerIndex",
  components: {
    Customer,
    Product,
    Cart,
    GenericContainer,
    // "last-sales": LastSales
  },
  filters: filters,
  data() {
    return {
      header_buttons: [
        {
          icon: "blue save",
          tooltip: this.$t("save"),
          click: this.save,
        },
      ],
      quotation: {
        name: "",
        description: "",
      },
    };
  },
  methods: {
    add_to_cart(product) {
      this.$refs.point_of_sale_cart.add_to_cart(product);
    },
    select_customer(customer) {
      this.$refs.point_of_sale_cart.select_customer(customer);
    },
    save() {
      let vm = this;
      let isValid = window.jQuery(vm.$refs.form).form("validate form");

      if (isValid) {
        local_api(vm, "post", "/quotation/do-save", {
          i: vm.quotation.uuid || null,
          s: {
            general: {
              name: vm.quotation.name,
              customer_id: null,
              description: vm.quotation.description,
            },
            products: vm.$refs.point_of_sale_cart.get_product_list(),
          },
        })
          .then((quotation) => {
            console.log(quotation);
            success_toast(vm.$t("quotation saved"));
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
  },
  mounted() {
    let vm = this;

    window.jQuery(vm.$refs.form).form({
      fields: {
        name: ["empty"],
      },
    });
    // load_submodules(vm, "point of sale");
  },
  watch: {},
};
</script>
